import React from "react";

const OPTIONS = [1, 2, 3, 4, 5];

const WellBeingRatingInput = ({ value, onChange }) => {
  return (
    <div className="wellbeing-rating-pills" role="group">
      {OPTIONS.map((option) => {
        const isActive = value === option;
        return (
          <button
            key={option}
            type="button"
            className={`wellbeing-rating-pill${isActive ? " is-active" : ""}`}
            aria-pressed={isActive}
            onClick={() => onChange?.(option)}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
};

export default WellBeingRatingInput;
